<script lang="ts">
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { cn } from '$lib/utils/cn';

    import type { Language } from '$lib/types/Language';

    export let onPlayClick: () => void = () => null;
    export let src = '';
    export let loading = true;
    export let language: Language = 'en';

    const videoBorderRadiusClass = getBorderRadius('video');
</script>

<div class={cn('wrapper fun-size-full', videoBorderRadiusClass, 'fun-rounded-b-none')}>
    <div class="content fun-flex fun-flex-col fun-items-center fun-justify-center">
        {#if loading}
            <div class="loading" />
        {:else}
            <img {src} class="previewImage" alt="video preview" />
            <div class="videoThumbnailOverlay">
                <button
                    class="iconWrapper"
                    on:click={onPlayClick}
                    aria-label={language === 'de' ? 'Video abspielen' : 'Play video'}
                >
                    <svg
                        width="42px"
                        height="42px"
                        viewBox="0 0 42 42"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <defs />
                        <g
                            id="Page-1"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                        >
                            <g id="video-play" transform="translate(1.000000, 1.000000)">
                                <circle
                                    id="Oval"
                                    stroke="#FFFFFF"
                                    fill-opacity="0.200000018"
                                    fill="#000000"
                                    cx="20"
                                    cy="20"
                                    r="20"
                                />
                                <path
                                    d="M25.023914,20.7808688 L17.624695,26.700244 C17.1934331,27.0452535 16.5641407,26.9753321 16.2191312,26.5440702 C16.0772808,26.3667572 16,26.1464466 16,25.9193752 L16,14.0806248 C16,13.5283401 16.4477153,13.0806248 17,13.0806248 C17.2270715,13.0806248 17.447382,13.1579056 17.624695,13.299756 L25.023914,19.2191312 C25.4551759,19.5641407 25.5250973,20.1934331 25.1800878,20.624695 C25.133956,20.6823598 25.0815787,20.734737 25.023914,20.7808688 Z"
                                    id="Triangle"
                                    fill="#FFFFFF"
                                />
                            </g>
                        </g>
                    </svg>
                </button>
            </div>
        {/if}
    </div>
</div>

<style lang="scss">
    @import '../_utils/variables';

    .wrapper {
        position: relative;
        background-color: black;
        overflow: hidden;

        &:before {
            display: block;
            content: '';
            width: 100%;
            padding-top: 56.25%;
        }

        .loading {
            color: transparent !important;
            pointer-events: none;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            &:after {
                border-color: transparent transparent $grey2 $grey2 !important;
                -webkit-animation: spin-around 700ms infinite linear;
                animation: spin-around 700ms infinite linear;
                border: 4px solid $grey2;
                border-radius: 290486px;
                border-right-color: transparent;
                border-top-color: transparent;
                content: '';
                display: block;
                height: 48px;
                width: 48px;
            }
        }

        .content {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            .previewImage {
                width: 100%;
            }

            .videoThumbnailOverlay {
                position: absolute;
                z-index: 2;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-image: linear-gradient(
                    rgba(0, 0, 0, 0) 0%,
                    rgba(0, 0, 0, 0.4) 50%,
                    rgba(0, 0, 0, 1) 100%
                );
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .iconWrapper {
                cursor: pointer;
                line-height: 0;
                border-radius: 50%;
                animation: pulse-shadow 2s infinite;
            }
        }
    }
</style>
